import React from 'react';

const QwenOpenSource = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Alibaba's Qwen team has been releasing open-source models faster than almost anyone
      else in the industry. By early 2025, Qwen2.5 had become one of the most downloaded
      model families on Hugging Face, and Qwen3 - with its unique hybrid reasoning approach -
      was setting new benchmarks for open-source efficiency. For the AI development
      community, Qwen has become a serious alternative to proprietary APIs.
    </p>

    <h2>The Qwen model family - what's been released</h2>
    <p>
      The Qwen family covers a wide range of sizes and tasks:
    </p>
    <ul>
      <li><strong>Qwen2.5:</strong> Base language models from 0.5B to 72B parameters</li>
      <li><strong>Qwen2.5-Coder:</strong> Specialised coding models competitive with much larger general models</li>
      <li><strong>Qwen2.5-Math:</strong> Mathematical reasoning models that outperform many proprietary alternatives</li>
      <li><strong>QwQ-32B:</strong> A 32-billion parameter reasoning model (think DeepSeek-R1 style) that performs close to models three times its size</li>
      <li><strong>Qwen3:</strong> The latest generation, with a hybrid thinking/non-thinking mode</li>
    </ul>

    <h2>Qwen3 - the hybrid reasoning model</h2>
    <p>
      Qwen3, released in April 2025, introduced something interesting: a switchable reasoning mode.
    </p>
    <ul>
      <li><strong>Thinking mode:</strong> Slower, step-by-step reasoning for complex problems</li>
      <li><strong>Non-thinking mode:</strong> Fast, direct responses for simple queries</li>
    </ul>
    <p>
      You can switch between modes mid-conversation, or let the model decide which to use
      based on the question. This is a practical design choice - you don't want a model
      spending 30 seconds "thinking" about what day of the week it is.
    </p>
    <p>
      Qwen3-235B-A22B, the largest variant, matched or exceeded GPT-4.1 and Claude 3.7
      Sonnet on several coding and reasoning benchmarks - while being fully open-source.
    </p>

    <h2>Why it matters for developers</h2>
    <p>
      Most open-source models have a real quality gap compared to frontier proprietary models.
      Qwen has been narrowing that gap faster than most. For developers who can't or don't
      want to use proprietary APIs - because of cost, data privacy, latency, or licensing -
      Qwen2.5 and Qwen3 are genuinely competitive options.
    </p>
    <p>
      The multilingual support is also a real differentiator. Qwen models perform significantly
      better than most Western models on Chinese, Malay, Thai, Vietnamese, and other Asian
      languages. For Southeast Asian applications, that matters a lot.
    </p>

    <h2>Alibaba's strategic bet</h2>
    <p>
      Open-source releases cost Alibaba money in compute and engineering time. Why do it?
      Because a widely used open-source model builds an ecosystem around Alibaba Cloud.
      Developers who fine-tune Qwen models tend to deploy on Alibaba infrastructure. It's
      the same play as Google with Android or Meta with Llama - give away the model to
      own the platform.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Qwen has proven that open-source AI can be genuinely competitive with frontier
        proprietary models, especially when a well-resourced company treats it as a strategic
        priority. For Southeast Asian developers especially, Qwen's multilingual performance
        and open licensing make it one of the most practical model families available today.
      </p>
    </div>
  </article>
);

export default QwenOpenSource;
